import type { ClientAccount } from "../../../api/generated";
import type { AccountTypeCount } from "../../types";

import {
  createReportContext,
  type InferReport,
} from "../../../context/ReportContext";

const accountReport = createReportContext({
  rebateAccountIDs: "multi",
  rebateProgramIDs: "multi",
})<
  { rebateAccountIDs: string; rebateProgramIDs: string },
  {
    table: {
      accountList: ClientAccount[];
      totalCount: number;
      redactedFields: string[];
    };
    stats: {
      platformAccounts: AccountTypeCount[];
      accountsType: AccountTypeCount[];
      total: number;
    };
    csv: void;
  },
  {
    selected: {
      rebateAccountIDs: string[] | null;
      rebateProgramIDs: string[] | null;
    };
    search: string;
    page: number;
    pageSize: number;
    sortColumn: string | null;
    sortDesc: boolean | null;
  }
>();

export const {
  Provider: ClientAccountReportContextProvider,
  useReportContext: useClientAccountReportContext,
} = accountReport;

export type AccountReportParams = InferReport<typeof accountReport, "params">;
export type AccountReportStates = InferReport<typeof accountReport, "states">;
